import DataStorage from "./DataStorage";
import jsonFetch from "./jsonFetch";

const authHeaders = () => ({
  "X-User-Email": DataStorage.getUserEmail(),
  "X-User-Token": DataStorage.getUserToken(),
});

const authFetch = (url, options = {}) => {
  const headers = {
    headers: {
      ...authHeaders(),
    },
  };

  return jsonFetch(url, { ...options, ...headers });
};

export const authBinaryFetch = (url, options = {}) =>
  fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      ...authHeaders(),
    },
  });

export default authFetch;
